// orAmenities
/**
 * @deprecated there's another copy of this in the filters package
 */
export const FILTER_GROUP_ON_SITE_LAUNDRY = ['l1', 'b4']
